// Maximum time an open tab may wait before picking up a newly deployed build.
// The service worker polls on this cadence; clients.claim() then triggers
// window.location.reload() via vite-plugin-pwa's controllerchange listener.
export const SW_UPDATE_INTERVAL_MS = 60_000
